import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'

import { getLanguageSymbol } from 'utils/languages'

export const LanguageCell = ({ language, hasIncreasedHeight }) => (
  <Table.Cell type="body" {...{ hasIncreasedHeight }}>
    <Box align="center" justify="center" tagName="span">
      {getLanguageSymbol(language)}
    </Box>
  </Table.Cell>
)
